<div class="form-content-item">
  <div class="top-title-btns">
    <div class="title-with-back">
      <button *ngIf="!hideTitle" mat-stroked-button class="back-button" (click)="goBack()">
        <mat-icon class="btn-icon">arrow_back</mat-icon>
        {{ 'common_btn_back' | translate }}
      </button>
      <h1 class="title" *ngIf="!hideTitle">{{ 'synthese_title' | translate }}</h1>
    </div>

    <div>
      <button mat-raised-button class="primary-action" *ngIf="buttonsConfig.generatePdf.visibility !== 'hidden'" [disabled]="buttonsConfig.generatePdf.visibility === 'disabled'" (click)="onGeneratePdfClick()">
        <mat-icon class="btn-icon">picture_as_pdf</mat-icon>
        {{ 'synthese_btn_generate_pdf' | translate }}
      </button>
      <button mat-raised-button *ngIf="buttonsConfig.extractExcel.visibility !== 'hidden'" [disabled]="buttonsConfig.extractExcel.visibility === 'disabled' || isExtractingExcel" (click)="onExtractExcelClick()">
        <mat-icon class="btn-icon" [class.spinning]="isExtractingExcel">{{ isExtractingExcel ? 'sync' : 'table_chart' }}</mat-icon>
        {{ (isExtractingExcel ? 'synthese_btn_extracting_excel' : 'synthese_btn_extract_excel') | translate }}
      </button>
      <button mat-raised-button *ngIf="buttonsConfig.checkData.visibility !== 'hidden'" [disabled]="buttonsConfig.checkData.visibility === 'disabled'" (click)="onCheckDataClick()">
        <mat-icon class="btn-icon">fact_check</mat-icon>
        {{ 'synthese_btn_check_data' | translate }}
      </button>
    </div>
  </div>

  <mat-tab-group animationDuration="0ms" class="row" [selectedIndex]="0">
    <mat-tab [label]="'synthese_tab_tables' | translate">
      <div class="mt-5">
        <mat-tab-group animationDuration="0ms" class="row" [selectedIndex]="0">
          <mat-tab *ngFor="let tab of tabs" [disabled]="!tab.enabled" [label]="tab.title">
            <div class="indicator">
              <h2>{{ tab.value?.displayTitle | localizedLabel: 'synthese' }}</h2>
              <h3>{{ tab.value?.measure | localizedLabel: 'synthese' }}</h3>
              <div *ngIf="tab.type === 'standard'">
                <div *ngFor="let solution of getSolutionsForTab(tab)" class="solution-table-container">
                  <p class="solution-title">{{ solution.displayName | localizedLabel: 'synthese' }}</p>

                  <mat-table [dataSource]="getSolutionDataSource(solution)">
                    <ng-container matColumnDef="operationType">
                      <mat-header-cell *matHeaderCellDef>{{ 'synthese_col_project_nature' | translate }}</mat-header-cell>
                      <mat-cell *matCellDef="let element" class="solution-background width-td">
                        <mat-icon *ngIf="element.operationType === 'Total'">chevron_right</mat-icon>
                        {{ element.operationType | localizedLabel: 'synthese' }}
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="operationName">
                      <mat-header-cell *matHeaderCellDef>{{ 'synthese_col_operations' | translate }}</mat-header-cell>
                      <mat-cell *matCellDef="let element" class="solution-background width-td">
                        {{ element.operationName }}
                      </mat-cell>
                    </ng-container>
                    <ng-container *ngFor="let header of headerValue(tab.value?.headers)" [matColumnDef]="header">
                      <mat-header-cell *matHeaderCellDef>{{ header | localizedLabel: 'synthese' }}</mat-header-cell>
                      <mat-cell
                        *matCellDef="let element"
                        [class.bold]="element.displayName == 'Comparaison / Base'"
                        [style.background-color]="element.color"
                        [class.total-background]="element.operationType == 'Total' || (element.displayName == 'Comparaison / Base' && projectIsEarthwork && projectIsRoad)">
                        {{ getDisplayValue(tab.code, element.values[getHeaderKey(tab.value?.headers, header)]) }}
                      </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="getDisplayedColumnsForSolution(tab)"></mat-header-row>
                    <mat-row
                      *matRowDef="let row; columns: getDisplayedColumnsForSolution(tab)"
                      [ngClass]="{
                        'total-blue-row': row.operationType === 'Total'
                      }"></mat-row>
                  </mat-table>
                </div>
              </div>

              <mat-table *ngIf="tab.type === 'special'" [dataSource]="getDataSource(tab)">
                <ng-container matColumnDef="icon">
                  <mat-header-cell *matHeaderCellDef>
                    <mat-icon>{{ tab.icon }}</mat-icon>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element"></mat-cell>
                </ng-container>

                <ng-container matColumnDef="solution">
                  <mat-header-cell *matHeaderCellDef>{{ tab.value?.tableTitle | localizedLabel: 'synthese' }}</mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.displayName }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="indicator">
                  <mat-header-cell *matHeaderCellDef>{{ 'synthese_col_indicator' | translate }}</mat-header-cell>
                  <mat-cell *matCellDef="let element" class="earthwork-background">
                    {{ getSpecialIndicatorValue(element, tab.code) }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="commitment">
                  <mat-header-cell *matHeaderCellDef>{{ 'synthese_col_commitment' | translate }}</mat-header-cell>
                  <mat-cell *matCellDef="let element" class="earthwork-background">
                    {{ element.commitment }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="justification">
                  <mat-header-cell *matHeaderCellDef>{{ 'synthese_col_justification' | translate }}</mat-header-cell>
                  <mat-cell *matCellDef="let element" class="earthwork-background">
                    {{ getSpecialJustificationValue(element, tab.code) }}
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="getDisplayedColumns(tab)"></mat-header-row>
                <mat-row
                  *matRowDef="let row; columns: getDisplayedColumns(tab)"
                  [ngClass]="{
                    'total-blue-row': row.operationType === 'Total'
                  }"></mat-row>
              </mat-table>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </mat-tab>

    <mat-tab [label]="'synthese_tab_graphs' | translate">
      <div>
        <mat-tab-group class="row graph-tabs text-center mt-5" animationDuration="0ms">
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="chart-tab">
                <mat-icon>bar_chart</mat-icon>
                <span class="short-span">{{ 'synthese_graph_synthetic_results' | translate }}</span>
              </div>
            </ng-template>
            <mat-divider class="mt-3"></mat-divider>
            <app-bar-indicators-detailed-bySolutions [isEcoPro]="false" [synthese]="syntheseToGraphValues" [indicators]="synthetiqueResultIndicators" [indicatorsToDisplay]="'EN'"> </app-bar-indicators-detailed-bySolutions>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="chart-tab">
                <mat-icon svgIcon="radar"></mat-icon>
                <span class="short-span">{{ 'synthese_graph_radar' | translate }}</span>
              </div>
            </ng-template>
            <mat-divider class="mt-3"></mat-divider>
            <app-radar-indicators [isEcoPro]="false" [synthese]="syntheseToGraphValues" [indicators]="indicators"> </app-radar-indicators>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="chart-tab">
                <mat-icon>bar_chart</mat-icon>
                <span class="short-span">{{ 'synthese_graph_scenario_module' | translate }}</span>
              </div>
            </ng-template>
            <mat-divider class="mt-3"></mat-divider>
            <app-bar-indicators-global-byStations [isEcoPro]="false" [synthese]="syntheseToGraphValues" [indicators]="synthetiqueResultDetailByModule"> </app-bar-indicators-global-byStations>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="chart-tab">
                <mat-icon>bar_chart</mat-icon>
                <span class="short-span">{{ 'synthese_graph_module_scenario' | translate }}</span>
              </div>
            </ng-template>
            <mat-divider class="mt-3"></mat-divider>
            <app-bar-indicators-detailed-byStations [isEcoPro]="false" [synthese]="syntheseToGraphValues" [indicators]="synthetiqueResultDetailByStation"> </app-bar-indicators-detailed-byStations>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <div class="chart-tab">
                <mat-icon>donut_small</mat-icon>
                <span>{{ 'synthese_graph_detail_scenario_module' | translate }}</span>
              </div>
            </ng-template>
            <mat-divider class="mt-3"></mat-divider>
            <app-sunburst-indicators-byStations [isEcoPro]="false" [synthese]="sunburstValuesToGraph" [indicators]="indicators"> </app-sunburst-indicators-byStations>
          </mat-tab>
        </mat-tab-group>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<div id="hidden-container" style="display: none"></div>

<div style="display: none">
  <div class="indicator" id="energy">
    <ng-container>
      <h2>{{ energyValues?.displayTitle }}</h2>
      <h3>{{ energyValues?.measure }}</h3>
      <table #energyTable>
        <tr>
          <th class="table-header" rowspan="2" colspan="2">
            <span>
              <mat-icon>tungsten</mat-icon>
            </span>
          </th>
          <th class="table-header" colspan="8">{{ energyValues?.tableTitle }}</th>
        </tr>
        <tr>
          <th class="table-header" *ngFor="let header of headerValue(energyValues?.headers)">{{ header }}</th>
        </tr>
        <tbody>
          <ng-container *ngFor="let sol of energyValues?.solutions">
            <tr>
              <td [class]="{ bold: sol.displayName == 'Comparaison / Base' }" class="solution-background width-td">
                {{ sol?.displayName }}
              </td>
              <ng-container>
                <tr *ngFor="let operationType of sol.operationTypes">
                  <td
                    [class.bold]="sol.displayName == 'Comparaison / Base'"
                    [class.total-background]="operationType?.operationType == 'Total' || (sol.displayName == 'Comparaison / Base' && projectIsEarthwork && projectIsRoad)"
                    [style.background-color]="operationType?.color"
                    class="width-td"
                    colspan="1">
                    {{ operationType?.operationType }}
                  </td>
                  <td class="fill-td2">
                    <tr *ngFor="let operation of operationType.operations">
                      <td
                        class="fill-td"
                        [class.bold]="sol.displayName == 'Comparaison / Base'"
                        [class.total-background]="operationType?.operationType == 'Total' || (sol.displayName == 'Comparaison / Base' && projectIsEarthwork && projectIsRoad)"
                        [style.background-color]="operationType?.color">
                        {{ operation?.operationName }}
                      </td>
                    </tr>
                  </td>
                </tr>
                <tr>
                  <td class="total-background fill-td" rowspan="3" colspan="3" *ngIf="sol?.totalValues; else compareBlock2">{{ 'project_total' | translate }}</td>
                  <ng-template #compareBlock2>
                    <td class="total-background fill-td" rowspan="3" colspan="3" *ngFor="let row of sol.rows">
                      {{ row.rowTitle }}
                    </td>
                  </ng-template>
                </tr>
              </ng-container>
              <td *ngFor="let header of rowValue(energyValues?.headers)" class="parent-comparison">
                <ng-container *ngFor="let operationType of sol.operationTypes">
                  <tr *ngFor="let operation of operationType.operations">
                    <td
                      [class.bold]="sol.displayName == 'Comparaison / Base'"
                      [class.road-background]="operationType?.operationType == 'Route/VRD' || (sol.displayName == 'Comparaison / Base' && projectIsRoad && !projectIsEarthwork)"
                      [class.earthwork-background]="operationType?.operationType == 'Terrassement' || (sol.displayName == 'Comparaison / Base' && projectIsEarthwork && !projectIsRoad)"
                      [class.total-background]="operationType?.operationType == 'Total' || (sol.displayName == 'Comparaison / Base' && projectIsEarthwork && projectIsRoad)"
                      class="width-td fill-td"
                      *ngIf="header != 'ComparisonBase'">
                      {{ operation?.values[header] }}
                    </td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="sol?.totalValues; else compareBlock">
                  <td *ngIf="header != 'ComparisonBase'; else comparisonBlock" class="total-background fill-td">
                    {{ sol?.totalValues[header] }}
                  </td>
                  <ng-template #comparisonBlock>
                    <td class="total-background comparison-div">
                      {{ sol?.totalValues[header] }}
                    </td>
                  </ng-template>
                </ng-container>
                <ng-template #compareBlock>
                  <ng-container *ngFor="let row of sol.rows">
                    <td class="total-background fill-td" *ngIf="header != 'ComparisonBase'; else comparisonBlock">
                      {{ row?.values[header] }}
                    </td>
                    <ng-template #comparisonBlock>
                      <td class="total-background comparison-div">
                        {{ row?.values[header] }}
                      </td>
                    </ng-template>
                  </ng-container>
                </ng-template>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </ng-container>
  </div>
</div>
